// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';
var ExternalSubscriptionCreateContractController = function ($scope, $location, $routeParams, $http, Order) {
    $scope.order = new Order();
    $scope.order.Customer = { CompanyName : null };
    $scope.order.ExternalSubscriptionId = $routeParams["id"];
    $scope.saveClicked = false;

    $scope.saveContract = function () {
        if ($scope.saveClicked)
            return;

        $scope.saveClicked = true;

        $scope.order.$save({}, function (data) {
            $http({
                method: "POST", url: "/api/v1/orders/" + data.Id + "/commit", params: null,
                data: { }, headers: { "Content-Type": "application/json" }, cache: false
            }).then(function (response) {
                $location.path("/contracts/" + response.data.Id);
            });
        }, function () {
            $scope.saveClicked = false;
        });
    };
};
ExternalSubscriptionCreateContractController.$inject = ['$scope', '$location', '$routeParams', '$http', 'Order'];
